import { AppRouteProps } from "@mzara/component";
import { ContractSalaryCreateRoutes } from "./create/ContractSalaryCreateRoutes";

export const ContractSalaryViewsRoutes: Array<AppRouteProps> = [
    ...ContractSalaryCreateRoutes
]